import { render, staticRenderFns } from "./login-view.vue?vue&type=template&id=ba45e3ee&scoped=true"
import script from "./login-view.vue?vue&type=script&lang=js"
export * from "./login-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba45e3ee",
  null
  
)

export default component.exports